import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";
// import "./Product.scss";
import accostayImage from "../Images/accostay.png";
import trackvantaImage from "../Images/dashboard.png";
import { segment } from "../../segment";

export const Product = () => {
  const { t } = useTranslation();

  return (
    <div 
      id="products" 
      className="py-12 px-4 sm:px-6 lg:px-8 mb-10" 
      style={{ 
        backgroundImage: `url(${""})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center' 
      }}
    >
      {/* Centered Heading */}
      <div className="text-center mb-16">
        <div className="flex justify-center items-center mb-6">
          <svg
            width="129"
            height="27"
            viewBox="0 0 129 27"
            fill="#ffffff"
            xmlns="http://www.w3.org/2000/svg"
            className="w-24 h-auto sm:w-32"
          >
            <rect width="4" height="27" fill="#ffffff" />
            <rect x="25" width="4" height="27" fill="#ffffff" />
            <rect x="50" width="4" height="27" fill="#ffffff" />
            <rect x="75" width="4" height="27" fill="#ffffff" />
            <rect x="100" width="4" height="27" fill="#ffffff" />
            <rect x="125" width="4" height="27" fill="#ffffff" />
          </svg>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-geo font-bold text-[#EF3B3B]">
          {t("products.title")}
        </h2>
      </div>
      
      {/* AccoStay Section */}
      <div className="max-w-7xl mx-auto mb-20">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
          {/* Left Content */}
          <div className="lg:w-1/2 rtl:lg:ml-[40rem] rtl:text:right order-2 lg:order-1">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-geo font-bold text-[#EF3B3B] mb-6">
              {t("products.accostay.title")}
            </div>
            <div className="text-white font-normal text-base sm:text-lg lg:text-xl leading-relaxed mb-8 wow slideInLeft">
              {t("products.accostay.description")}
            </div>
            <div className="text-lg">
              <a
                href="https://accostay.com"
                onClick={() => segment("AccoStay link clicked", {})}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-black py-3 px-6 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300"
              >
                {t("products.accostay.buttonText")}
              </a>
            </div>
          </div>
          
          {/* Right Image */}
          <div className="lg:w-1/2 rtl:lg:mr-[44rem]  rtl:lg:-mt-[24rem]  order-1 lg:order-2 flex justify-center wow slideInRight">
            <img 
              src={accostayImage} 
              alt={t("products.accostay.title")}
              className="w-full max-w-md lg:max-w-full h-auto rounded-lg shadow-lg" 
            />
          </div>
        </div>
      </div>

      {/* Trackvanta Section */}
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
          {/* Left Image */}
          <div className="lg:w-1/2 order-1 rtl:lg:ml-[49rem] flex justify-center wow slideInLeft">
            <img 
              src={trackvantaImage} 
              alt={t("products.trackvanta.title")}
              className="w-full max-w-md lg:max-w-full h-auto rounded-lg shadow-lg transform -rotate-3 scale-105" 

            />
          </div>

          {/* Right Content */}
          <div className="lg:w-1/2 rtl:lg:mr-[40rem]  rtl:lg:-mt-[20rem] order-2">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-geo font-bold text-[#EF3B3B] mb-6">
              {t("products.trackvanta.title")}
            </div>
            <div className="text-white font-normal text-base sm:text-lg lg:text-xl leading-relaxed mb-8 wow slideInRight">
              {t("products.trackvanta.description")}
            </div>
            <div className="text-lg">
              <a
                href="https://trackvanta.com"
                onClick={() => segment("Trackvanta link clicked", {})}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-black py-3 px-6 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300"
              >
                {t("products.trackvanta.buttonText")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;